<template>
    <Card>
        <template v-slot:header>
            <h2>实体排名</h2>
            <el-select v-model="type" size="mini" @change="changeType" style="width: 100px; margin-left: 20px">
                <el-option :value="1" label="人流量">人流量</el-option>
                <el-option :value="2" label="在场人数">在场人数</el-option>
                <el-option :value="3" label="人流密度">人流密度</el-option>
                <el-option :value="4" label="停留时间">停留时间</el-option>
            </el-select>
        </template>
        <div class="card-content rank-chart">
            <ul class="rank-list" v-if="dataList.length > 0">
                <li v-for="(item, index) in dataList" :key="index">
                    <div>
                        <span>{{ index + 1 }}、{{ item.ChildName }} </span>
                    </div>
                    <div class="num">
                        <span>{{ item.DataIn }} </span>
                    </div>
                </li>
            </ul>
        </div>
    </Card>
</template>
<script>
export default {
    name: "SingleRankData",
    data() {
        return {
            type: 1,
            dataList: [],
        };
    },
    methods: {
        setData(data) {
            this.$ajax.post("/FlowData/GetAllChildShopRank", data).then((result) => {
                this.dataList = result.Data;
            });
        },
    },
};
</script>
<style scoped>
.rank-chart {
    height: 325px;
    width: 100%;
    display: inline-block;
}

ul.rank-list {
    width: 100%;
    height: 300px;
    overflow: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}
ul.rank-list li {
    width: 100%;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    color: #333;
    font-size: 16px;
}
ul.rank-list li span.tag1 {
    color: #dc6f69;
}
ul.rank-list li span.tag2 {
    color: #ffa800;
}
ul.rank-list li > div {
    flex: 1;
}
ul.rank-list li > div.num {
    flex: none;
    width: 100px;
}
</style>
